// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"6a4e61c4","3241":"407aa1d6","3400":"6a4e61c4","3584":"6a4e61c4","4356":"6a4e61c4","6355":"6a4e61c4","7380":"6a4e61c4"}[chunkId] + ".css";
};